module.exports = __webpack_public_path__ + "img/2025-04-07.0b3aa12.png";